import { ClassValue, clsx } from 'clsx';
import { useAppContext } from 'contexts/appContext';
import { BrandCode } from 'lib/config/config';
import styles from './Icon.css';

export interface IconProps {
	className?: ClassValue;
}

export const CaretIcon = (props: Readonly<IconProps>) => {
	const { brandCode } = useAppContext();

	const brandIcon = {
		[BrandCode.RoyalCaribbean]: (
			<svg className={clsx(styles.root, props.className)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.7483 4.99997C13.3749 4.56762 12.7216 4.51989 12.2893 4.89337L8 8.59852L3.71074 4.89337C3.27838 4.51989 2.62513 4.56762 2.25165 4.99997C1.87817 5.43233 1.9259 6.08558 2.35826 6.45906L7.32376 10.7484C7.71216 11.0839 8.28784 11.0839 8.67624 10.7484L13.6417 6.45906C14.0741 6.08558 14.1218 5.43233 13.7483 4.99997Z"
				/>
			</svg>
		),

		[BrandCode.Celebrity]: (
			<svg className={clsx(styles.root, props.className)} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.4737 5.9708L14.5 5.6291L13.9833 5.02628L13.6416 5L8.5 9.40709L3.3584 5L3.0167 5.02629L2.5 5.6291L2.52628 5.9708L8.08394 10.7345L8.24165 10.7928L8.75835 10.7928L8.91606 10.7345L14.4737 5.9708Z"
				/>
			</svg>
		),
	};

	return brandIcon[brandCode];
};

export const FilterIcon = (props: Readonly<IconProps>) => {
	return (
		<svg className={clsx(styles.root, props.className)} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4611 5.15869C10.1689 5.15869 9.07048 6.03094 8.71513 7.22624H5.77533C5.32305 7.22624 5 7.5816 5 8.03388C5 8.48615 5.35536 8.84151 5.80764 8.84151H8.74743C9.07048 10.0368 10.2012 10.9091 11.4934 10.9091C12.8179 10.9091 13.9163 10.0368 14.2717 8.84151H26.1924C26.6446 8.84151 27 8.48615 27 8.03388C27 7.5816 26.6446 7.22624 26.1924 7.22624H14.2717C13.884 6.03094 12.7856 5.15869 11.4611 5.15869ZM11.4934 6.77396C12.1718 6.77396 12.7533 7.32316 12.7533 8.03388C12.7533 8.7446 12.1718 9.29379 11.4934 9.29379C10.815 9.29379 10.2335 8.7446 10.2335 8.03388C10.2335 7.32316 10.815 6.77396 11.4934 6.77396Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.185 13.1091C19.8928 13.1091 18.7944 13.9813 18.4391 15.1766H5.80764C5.32305 15.1766 5 15.532 5 15.9842C5 16.4365 5.35536 16.7919 5.80764 16.7919H18.4391C18.7621 17.9872 19.8928 18.8594 21.185 18.8594C22.5095 18.8594 23.6079 17.9872 23.9633 16.7919H26.1924C26.6446 16.7919 27 16.4365 27 15.9842C27 15.532 26.6446 15.1766 26.1924 15.1766H23.9633C23.6079 13.9813 22.5095 13.1091 21.185 13.1091ZM21.2173 14.7243C21.8957 14.7243 22.4772 15.2735 22.4772 15.9842C22.4772 16.695 21.8957 17.2442 21.2173 17.2442C20.5389 17.2442 19.9574 16.695 19.9574 15.9842C19.9574 15.2735 20.5066 14.7243 21.2173 14.7243Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.5918 23.127C12.9471 21.9317 14.0455 21.0594 15.3377 21.0594C16.6623 21.0594 17.7606 21.9317 18.116 23.127H26.1924C26.6446 23.127 27 23.4823 27 23.9346C27 24.3869 26.6446 24.7422 26.1924 24.7422H18.1483C17.793 25.9376 16.6946 26.8098 15.37 26.8098C14.0778 26.8098 12.9471 25.9376 12.6241 24.7422H5.80764C5.35536 24.7422 5 24.3869 5 23.9346C5 23.4823 5.32305 23.127 5.80764 23.127H12.5918ZM16.63 23.9346C16.63 23.2239 16.0485 22.6747 15.37 22.6747C14.6916 22.6747 14.1424 23.2239 14.1101 23.9346C14.1101 24.6453 14.6916 25.1945 15.37 25.1945C16.0485 25.1945 16.63 24.6453 16.63 23.9346Z"
			/>
		</svg>
	);
};

export const CrossIcon = (props: Readonly<IconProps>) => {
	const { brandCode } = useAppContext();

	const brandIcon = {
		[BrandCode.RoyalCaribbean]: (
			<svg className={clsx(styles.root, props.className)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.95098 0.334735C1.50467 -0.111578 0.781049 -0.111578 0.334735 0.334735C-0.111578 0.781049 -0.111578 1.50467 0.334735 1.95098L6.38376 8L0.334735 14.049C-0.111578 14.4953 -0.111578 15.219 0.334735 15.6653C0.781049 16.1116 1.50467 16.1116 1.95098 15.6653L8 9.61624L14.049 15.6653C14.4953 16.1116 15.219 16.1116 15.6653 15.6653C16.1116 15.219 16.1116 14.4953 15.6653 14.049L9.61624 8L15.6653 1.95098C16.1116 1.50467 16.1116 0.781049 15.6653 0.334735C15.219 -0.111578 14.4953 -0.111578 14.049 0.334735L8 6.38376L1.95098 0.334735Z"
				/>
			</svg>
		),

		[BrandCode.Celebrity]: (
			<svg className={clsx(styles.root, props.className)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M20 4.68926L19.3107 4L12 11.3107L4.68926 4L4 4.68926L11.3107 12L4 19.3107L4.68926 20L12 12.6893L19.3107 20L20 19.3107L12.6893 12L20 4.68926Z" />
			</svg>
		),
	};

	return brandIcon[brandCode];
};

export const SearchIcon = (props: Readonly<IconProps>) => {
	return (
		<svg className={clsx(styles.root, props.className)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M15.5971 3.48769C17.2737 5.16563 18.1116 7.18817 18.1111 9.55556L15.6667 9.55501C15.667 7.83748 15.0876 6.43644 13.8686 5.21618C12.6717 4.02056 11.2816 3.44425 9.55583 3.44444C7.83436 3.44444 6.43245 4.01859 5.21621 5.21621C4.01859 6.43245 3.44444 7.83409 3.44444 9.55556C3.44425 11.2813 4.02056 12.6717 5.21618 13.8686C6.43644 15.0876 7.83748 15.667 9.55501 15.6667H9.55637C11.2741 15.6672 12.6612 15.0884 13.8598 13.8775L13.8686 13.8686L13.8775 13.8598C15.0884 12.6612 15.6672 11.2741 15.6667 9.55637L18.1111 9.55556C18.1118 11.5079 17.5423 13.2196 16.4024 14.6905C16.4472 14.7243 16.4901 14.7616 16.5309 14.8024L22.642 20.9135C23.1193 21.3908 23.1193 22.1647 22.642 22.642C22.1647 23.1193 21.3908 23.1193 20.9135 22.642L14.8024 16.5309C14.7616 16.4901 14.7243 16.4472 14.6905 16.4024C13.2196 17.5423 11.5079 18.1118 9.55556 18.1111C7.18817 18.1116 5.16563 17.2737 3.48769 15.5971C1.82897 13.9371 0.999737 11.9232 1 9.55556C1 7.18843 1.82923 5.16563 3.48769 3.48769C5.16563 1.82923 7.18843 1 9.55556 1C11.9232 0.999737 13.9371 1.82897 15.5971 3.48769Z" />
		</svg>
	);
};

export const LeftArrowIcon = (props: Readonly<IconProps>) => {
	return (
		<svg className={clsx(styles.root, props.className)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M4 11.9803C4.00041 11.7122 4.09959 11.4553 4.27572 11.266L10.3934 4.69242C10.7601 4.29832 11.3538 4.29939 11.7193 4.6948C12.0849 5.09022 12.0839 5.73025 11.7171 6.12435L7.20362 10.9743L19.0638 10.9928C19.5816 10.9936 20.0007 11.4468 20 12.0051C19.9992 12.5633 19.5789 13.0153 19.061 13.0144L7.19872 12.9959L11.7193 17.8859C12.0849 18.2813 12.0839 18.9214 11.7171 19.3155C11.3504 19.7096 10.7567 19.7085 10.3912 19.3131L4.27352 12.6956C4.09797 12.5057 3.99959 12.2484 4 11.9803Z" />
		</svg>
	);
};

export const PlusIcon = (props: Readonly<IconProps>) => {
	return (
		<svg className={clsx(styles.root, props.className)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M12.8 4.8C12.8 4.35817 12.4418 4 12 4C11.5582 4 11.2 4.35817 11.2 4.8V11.2H4.8C4.35817 11.2 4 11.5582 4 12C4 12.4418 4.35817 12.8 4.8 12.8H11.2V19.2C11.2 19.6418 11.5582 20 12 20C12.4418 20 12.8 19.6418 12.8 19.2V12.8H19.2C19.6418 12.8 20 12.4418 20 12C20 11.5582 19.6418 11.2 19.2 11.2H12.8V4.8Z" />
		</svg>
	);
};

export const MinusIcon = (props: Readonly<IconProps>) => {
	return (
		<svg className={clsx(styles.root, props.className)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 12C4 11.4477 4.35817 11 4.8 11L19.2 11C19.6418 11 20 11.4477 20 12C20 12.5523 19.6418 13 19.2 13H4.8C4.35817 13 4 12.5523 4 12Z"
			/>
		</svg>
	);
};
